import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import LoginRegisterPage from '../views/LoginRegisterPage.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import Contact from '../views/Contact.vue'
import ProductDetails from '../views/ProductDetails.vue'
import ProductsPage from '../views/ProductsPage.vue'
import UserProfile from '../views/UserProfile.vue'
import EditProductPage from '../views/EditProductPage.vue'
import Wishlist from '../views/WishList.vue'
import PrivacyPolicyPage from '../views/PrivacyPolicyPage.vue'
import CommissionTransfer from '../views/CommissionTransfer.vue'
import DeleteAccount from '../views/DeleteAccount.vue'
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/login',
    name: 'LoginRegisterPage',
    component: LoginRegisterPage
  },
  {
    path: '/delete-account',
    name: 'DeleteAccount',
    component: DeleteAccount
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsAndConditions
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/product/:id',
    name: 'ProductDetails',
    component: ProductDetails
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsPage
  },
  {
    path: '/userProfile',
    name: 'userProfile',
    component: UserProfile,
    meta: { requiresAuth: true }, 
  },
  {
  path: '/edit-product/:id',
  name: 'EditProduct',
  component: EditProductPage
},
{
  path: '/wishlist',
  name: 'Wishlist',
  component: Wishlist
},
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage
  },
  {
    path:'/commission',
    name: 'Commission',
    component: CommissionTransfer
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token') 

  if (to.meta.requiresAuth && !token) {
    next({ name: 'LoginRegisterPage' })
  } else {
    next()
  }
})

export default router
